import React from "react";
import ring5 from "../../../assets/common/ring.svg";

const Extra = (props) => {
  const timelineRow = {
    display: "flex",
    width: "90%",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    textAlign: "center",
    padding: "20px 20px",
    margin: "20px auto",
    boxSizing: "border-box",
  };

  const eventLabel = {
    fontSize: "13px",
    fontWeight: "600",
    color: "#3A3C3F",
    marginBottom: "4px",
    textAlign: "center",
  };

  const eventTime = {
    fontSize: "15px",
    fontWeight: "700",
    color: "#2c2c2c",
    textAlign: "center",
  };

  const parentBlock = {
    flex: 1,
    padding: "0 12px",
    margin: "0 6px",
  };

  const eventBlock = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minWidth: 0,
    padding: "0 10px",
    overflow: "hidden",
    boxSizing: "border-box",
  };

  return (
    <>
      <div style={timelineRow}>
        <div style={eventBlock}>
          <div style={eventLabel}>קבלת פנים</div>
          <div style={eventTime}>{props.data.hour1}</div>
        </div>
        <div
          style={{
            padding: "0 8px",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            alt="ring5"
            src={ring5}
            style={{ width: "40px", opacity: 0.9 }}
          />
        </div>
        <div style={eventBlock}>
          <div style={eventLabel}>חופה וקידושין</div>
          <div style={eventTime}>{props.data.hour2}</div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          marginTop: "20px",
          padding: "0 16px",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "stretch",
          textAlign: "center",
          gap: "12px",
        }}
      >
        <div style={parentBlock}>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#5a5a5a",
              marginBottom: "6px",
            }}
          >
            {props.data.family ? "משפחת" : "הורי"} הכלה
          </div>
          <div
            style={{ fontSize: "14px", fontWeight: "500", color: "#2c2c2c" }}
          >
            {props.data.brideParents.split("??").map((x, i) => (
              <div key={i + x}>{x}</div>
            ))}
          </div>
        </div>
        <div style={parentBlock}>
          <div
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#5a5a5a",
              marginBottom: "6px",
            }}
          >
            {props.data.family ? "משפחת" : "הורי"} החתן
          </div>
          <div
            style={{ fontSize: "14px", fontWeight: "500", color: "#2c2c2c" }}
          >
            {props.data.groomParents.split("??").map((x, i) => (
              <div key={i + x}>{x}</div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Extra;
